<template>
  <div class="workorder-banner">
    <img :src="mobileworkorderBanner" alt="" />
    <div class="absolute">
      <div class="title">数字家园工单系统</div>
      <div class="text">
        聚焦后台物业工单，智能统筹，实时部署，赋能物业，连接业主，实现智慧物业立体化管理，促进物业服务新模式升级。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobileworkorderBanner from "../../../../assets/product/mobileworkorderBanner.png";

export default {
  setup() {
    return reactive({
      mobileworkorderBanner: mobileworkorderBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.workorder-banner {
  position: relative;
}
.workorder-banner img {
 width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .text {
  font-size: 12px;
  margin-top: 10px;
  color: #fff;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 24px;
  color: #fff;
  border: 1px solid rgba(255,255,255,.8);
  text-align: center;
  cursor: pointer;
    width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
